/**
 * @ignore
 * Created by daletan on 6/17/16.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { formatPrice } = require('./helpers.es');
const styles = require('./pdp-price.scss');
const get = require('lodash.get');

const FormattedPrice = function(props) {
    const {
        copy,
        isSoldIndividually,
        currency,
        type,
        price,
        doNotShowFormattedPrice,
        priceDisplays,
    } = props;
    const { string, abbreviation, perItem } = doNotShowFormattedPrice
        ? {}
        : formatPrice({ copy, isSoldIndividually, price, currency });
    const displayPrice = doNotShowFormattedPrice ? price : string;
    let wrapperTn = 'price-wrapper';
    let priceTn = 'pdp-retail-price';
    if (priceDisplays.showOnHold) {
        priceTn = 'on-hold-price';
    } else if (priceDisplays.showPriceUponRequest) {
        priceTn = 'price-upon-request';
    } else if (type === 'net') {
        priceTn = 'pdp-net-price';
    }
    if (type) {
        wrapperTn = `${wrapperTn}-${type}`;
    }

    const retailPriceCopy = get(copy, 'priceStates.retailPrice') || '';
    const netPriceCopy = get(copy, 'priceStates.netPrice') || '';

    return (
        <span data-tn={wrapperTn}>
            <span data-tn={priceTn}>{displayPrice}</span>
            {doNotShowFormattedPrice ? (
                false
            ) : (
                <sup className={styles.sup} data-tn="price-abbreviation">
                    {abbreviation}
                </sup>
            )}
            {doNotShowFormattedPrice ? false : <span data-tn="price-per-item">{perItem}</span>}
            {type === 'retail' && priceDisplays.showListPriceLabel && !doNotShowFormattedPrice ? (
                <span> {retailPriceCopy}</span>
            ) : null}
            {type === 'net' && !doNotShowFormattedPrice ? (
                <span> {netPriceCopy}</span>
            ) : null}
        </span>
    );
};

FormattedPrice.defaultProps = {
    copy: {},
    isSoldIndividually: false,
    priceIsString: false,
};

FormattedPrice.propTypes = {
    copy: PropTypes.object.isRequired,
    isSoldIndividually: PropTypes.bool,
    doNotShowFormattedPrice: PropTypes.bool,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    priceDisplays: PropTypes.object.isRequired,
    currency: PropTypes.string.isRequired,
    type: PropTypes.string,
};

module.exports = FormattedPrice;



// WEBPACK FOOTER //
// ./assets/js/components/Price/FormattedPrice.jsx